import { Component, Injector, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractValueAccessor } from '../abstract-value-accessor';

@Component({
  template: '',
})
export class FileInputBasicComponent extends AbstractValueAccessor implements OnInit, OnChanges {
  set value(value: File | FileList | File[]) {
    const handledFiles = this.handleMIMEType(value);
    super.value = handledFiles;
  }

  get value(): any {
    return super.value;
  }

  get valueAsFile(): File {
    return super.value as File;
  }

  get valueAsFileArray(): File[] {
    return super.value as File[];
  }

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    super.ngOnChanges(simpleChanges);
  }

  private handleMIMEType(value: FileList | File | File[]): FileList | File | File[] | undefined {
    let fileData = value;

    if (!fileData) {
      return;
    }

    if (fileData instanceof FileList) {
      fileData = Array.from(fileData);
      const dataTransfer = new DataTransfer();

      fileData.forEach((file) => dataTransfer.items.add(this.handleSingleFileMIMEType(file)));
      return dataTransfer.files;
    }

    if (Array.isArray(fileData)) {
      return fileData.map((file) => this.handleSingleFileMIMEType(file));
    }
    return this.handleSingleFileMIMEType(fileData as File);
  }

  private handleSingleFileMIMEType(value: File): File {
    if (value.name.endsWith('.msg')) {
      const arrayBuffer = value.slice();
      return new File([arrayBuffer], value.name, { type: 'application/vnd.ms-outlook' });
    }

    return value;
  }
}
